import { render, staticRenderFns } from "./OriVideo.vue?vue&type=template&id=8e633caa&scoped=true&"
import script from "./OriVideo.vue?vue&type=script&lang=js&"
export * from "./OriVideo.vue?vue&type=script&lang=js&"
import style0 from "./OriVideo.vue?vue&type=style&index=0&id=8e633caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e633caa",
  null
  
)

export default component.exports